/** Cosmetic delay after the initial account check; Workbench starts immediately. */
export function initialAuthLoadingDelay(pathname: string): number {
  return /^\/(?:live-demo\/)?workbench\//.test(pathname) ? 0 : 300;
}
